import { ContentPromotionPostsValue } from '../ContentPromotionPosts/types';

export const POSTS_TEXT_MAPPING = {
    [ContentPromotionPostsValue.ALL]: 'Все посты',
    [ContentPromotionPostsValue.NEW]: 'Новые посты',
    [ContentPromotionPostsValue.CHOICE]: 'Выбранные посты',
};
